// eslint-disable-next-line no-undef
const Objects = {};

Objects.Titles = [
  { code: "0", title: "OTHERS" },
  { code: "1", title: "MR" },
  { code: "2", title: "MRS" },
  { code: "3", title: "MESSRS" },
  { code: "4", title: "MISS" },
  { code: "5", title: "MS" },
  { code: "6", title: "PROF" },
  { code: "7", title: "JUSTICE" },
  { code: "8", title: "JUDGE" },
  { code: "9", title: "DR" },
  { code: "10", title: "ENG." },
  { code: "11", title: "HAJ" },
  { code: "12", title: "SHEIKH" },
  { code: "13", title: "ALHAJI" },
  { code: "14", title: "OBA" },
  { code: "15", title: "ARCH" },
  { code: "16", title: "BARRISTER" },
  { code: "17", title: "REVEREND" },
  { code: "18", title: "MONSIGNOR" },
  { code: "19", title: "HIS BISHOP" },
  { code: "20", title: "PATRIARCH" },
  { code: "21", title: "BROTHER" },
  { code: "22", title: "HER MAJESTY" },
  { code: "23", title: "H.R.H." },
  { code: "24", title: "HONOURABLE" },
  { code: "25", title: "SENATOR" },
  { code: "26", title: "H.EX." },
  { code: "27", title: "HIS MAJESTY" },
  { code: "28", title: "MR & MRS" },
  { code: "29", title: "REV FR" },
  { code: "30", title: "AIR VICE MASHAL" },
  { code: "31", title: "ARC" },
  { code: "32", title: "ARCH BISHOP" },
  { code: "33", title: "BISHOP" },
  { code: "34", title: "CAPTAIN" },
  { code: "35", title: "CHIEF" },
  { code: "36", title: "CHIEF (DR)" },
  { code: "37", title: "CHIEF (MRS)" },
  { code: "38", title: "COLONEL" },
  { code: "39", title: "DAME" },
  { code: "40", title: "DEACON" },
  { code: "41", title: "DEACONESS" },
  { code: "42", title: "GENERAL" },
  { code: "43", title: "HIGH PRIEST" },
  { code: "44", title: "KING" },
  { code: "45", title: "LADY" },
  { code: "46", title: "LOLO" },
  { code: "47", title: "MAJOR" },
  { code: "48", title: "MALLAM" },
  { code: "49", title: "OTUNBA" },
  { code: "50", title: "PASTOR" },
  { code: "51", title: "PASTOR (MRS)" },
  { code: "52", title: "PRINCE" },
  { code: "53", title: "PRINCESS" },
  { code: "54", title: "QUEEN" },
  { code: "55", title: "SIR" },
  { code: "56", title: "SIR & LADY" },
  { code: "57", title: "ENGR DR." },
  { code: "58", title: "CARDINAL" },
  { code: "99", title: "OTHERS" },
];

Objects.Gender = [
  { code: "1", gender: "Male" },
  { code: "2", gender: "Female" },
];

Objects.MaritalValue = [
  { code: "1", status: "Single" },
  { code: "2", status: "Married" },
  { code: "3", status: "Divorced" },
  { code: "4", status: "Widow" },
  { code: "4", status: "Widower" },
  { code: "5", status: "Seperated" },
];

Objects.Countries = [

{ value: 'Afghanistan', label: 'Afghanistan' },
{ value: 'Albania', label: 'Albania' },
{ value: 'Algeria', label: 'Algeria' },
{ value: 'American Samoa', label: 'American Samoa' },
{ value: 'Andorra', label: 'Andorra' },
{ value: 'Angola', label: 'Angola' },
{ value: 'Anguilla', label: 'Anguilla' },
{ value: 'Antarctica', label: 'Antarctica' },
{ value: 'Antigua and Barbuda', label: 'Antigua and Barbuda' },
{ value: 'Argentina', label: 'Argentina' },
{ value: 'Armenia', label: 'Armenia' },
{ value: 'Aruba', label: 'Aruba' },
{ value: 'Australia', label: 'Australia' },
{ value: 'Austria', label: 'Austria' },
{ value: 'Azerbaijan', label: 'Azerbaijan' },
{ value: 'Bahamas', label: 'Bahamas' },
{ value: 'Bahrain', label: 'Bahrain' },
{ value: 'Bangladesh', label: 'Bangladesh' },
{ value: 'Barbados', label: 'Barbados' },
{ value: 'Belarus', label: 'Belarus' },
{ value: 'Belgium', label: 'Belgium' },
{ value: 'Belize', label: 'Belize' },
{ value: 'Benin', label: 'Benin' },
{ value: 'Bermuda', label: 'Bermuda' },
{ value: 'Bhutan', label: 'Bhutan' },
{ value: 'Bolivia', label: 'Bolivia' },
{ value: 'Bosnia and Herzegovina', label: 'Bosnia and Herzegovina' },
{ value: 'Botswana', label: 'Botswana' },
{ value: 'Brazil', label: 'Brazil' },
{ value: 'Brunei Darussalam', label: 'Brunei Darussalam' },
{ value: 'Bulgaria', label: 'Bulgaria' },
{ value: 'Burkina Faso', label: 'Burkina Faso' },
{ value: 'Burundi', label: 'Burundi' },
{ value: 'Cambodia', label: 'Cambodia' },
{ value: 'Cameroon', label: 'Cameroon' },
{ value: 'Canada', label: 'Canada' },
{ value: 'Cape Verde', label: 'Cape Verde' },
{ value: 'Cayman Islands', label: 'Cayman Islands' },
{ value: 'Central African Republic', label: 'Central African Republic' },
{ value: 'Chad', label: 'Chad' },
{ value: 'Chile', label: 'Chile' },
{ value: 'China', label: 'China' },
{ value: 'Christmas Island', label: 'Christmas Island' },
{ value: 'Cocos (Keeling) Islands', label: 'Cocos (Keeling) Islands' },
{ value: 'Colombia', label: 'Colombia' },
{ value: 'Comoros', label: 'Comoros' },
{ value: 'Democratic Republic of the Congo (Kinshasa)', label: 'Democratic Republic of the Congo (Kinshasa)' },
{ value: 'Congo, Republic of (Brazzaville)', label: 'Congo, Republic of (Brazzaville)' },
{ value: 'Cook Islands', label: 'Cook Islands' },
{ value: 'Costa Rica', label: 'Costa Rica' },
{ value: 'Croatia', label: 'Croatia' },
{ value: 'Cuba', label: 'Cuba' },
{ value: 'Cyprus', label: 'Cyprus' },
{ value: 'Czech Republic', label: 'Czech Republic' },
{ value: 'Denmark', label: 'Denmark' },
{ value: 'Djibouti', label: 'Djibouti' },
{ value: 'Dominica', label: 'Dominica' },
{ value: 'Dominican Republic', label: 'Dominican Republic' },
{ value: 'East Timor (Timor-Leste)', label: 'East Timor (Timor-Leste)' },
{ value: 'Ecuador', label: 'Ecuador' },
{ value: 'Egypt', label: 'Egypt' },
{ value: 'El Salvador', label: 'El Salvador' },
{ value: 'Equatorial Guinea', label: 'Equatorial Guinea' },
{ value: 'Eritrea', label: 'Eritrea' },
{ value: 'Estonia', label: 'Estonia' },
{ value: 'Ethiopia', label: 'Ethiopia' },
{ value: 'Falkland Islands', label: 'Falkland Islands' },
{ value: 'Faroe Islands', label: 'Faroe Islands' },
{ value: 'Federal States of Micronesia', label: 'Federal States of Micronesia' },
{ value: 'Fiji', label: 'Fiji' },
{ value: 'Finland', label: 'Finland' },
{ value: 'France', label: 'France' },
{ value: 'French Guiana', label: 'French Guiana' },
{ value: 'French Polynesia', label: 'French Polynesia' },
{ value: 'French Southern Territories', label: 'French Southern Territories' },
{ value: 'Gabon', label: 'Gabon' },
{ value: 'The Gambia', label: 'The Gambia' },
{ value: 'Georgia', label: 'Georgia' },
{ value: 'Germany', label: 'Germany' },
{ value: 'Ghana', label: 'Ghana' },
{ value: 'Gibraltar', label: 'Gibraltar' },
{ value: 'Greece', label: 'Greece' },
{ value: 'Greenland', label: 'Greenland' },
{ value: 'Grenada', label: 'Grenada' },
{ value: 'Guadeloupe', label: 'Guadeloupe' },
{ value: 'Guam', label: 'Guam' },
{ value: 'Guatemala', label: 'Guatemala' },
{ value: 'Guinea', label: 'Guinea' },
{ value: 'Guinea-Bissau', label: 'Guinea-Bissau' },
{ value: 'Guyana', label: 'Guyana' },
{ value: 'Haiti', label: 'Haiti' },
{ value: 'Holy See', label: 'Holy See' },
{ value: 'Honduras', label: 'Honduras' },
{ value: 'Hong Kong', label: 'Hong Kong' },
{ value: 'Hungary', label: 'Hungary' },
{ value: 'Iceland', label: 'Iceland' },
{ value: 'India', label: 'India' },
{ value: 'Indonesia', label: 'Indonesia' },
{ value: 'Iran (Islamic Republic of)', label: 'Iran (Islamic Republic of)' },
{ value: 'Iraq', label: 'Iraq' },
{ value: 'Ireland', label: 'Ireland' },
{ value: 'Israel', label: 'Israel' },
{ value: 'Italy', label: 'Italy' },
{ value: 'Ivory Coast', label: 'Ivory Coast' },
{ value: 'Jamaica', label: 'Jamaica' },
{ value: 'Japan', label: 'Japan' },
{ value: 'Jordan', label: 'Jordan' },
{ value: 'Kazakhstan', label: 'Kazakhstan' },
{ value: 'Kenya', label: 'Kenya' },
{ value: 'Kiribati', label: 'Kiribati' },
{ value: 'Kosovo', label: 'Kosovo' },
{ value: 'Kuwait', label: 'Kuwait' },
{ value: 'Kyrgyzstan', label: 'Kyrgyzstan' },
{ value: "Lao, People's Democratic Republic",label:"Lao, People's Democratic Republic"},
{ value: 'Latvia', label: 'Latvia' },
{ value: 'Lebanon', label: 'Lebanon' },
{ value: 'Lesotho', label: 'Lesotho' },
{ value: 'Liberia', label: 'Liberia' },
{ value: 'Libya', label: 'Libya' },
{ value: 'Liechtenstein', label: 'Liechtenstein' },
{ value: 'Lithuania', label: 'Lithuania' },
{ value: 'Luxembourg', label: 'Luxembourg' },
{ value: 'Macau', label: 'Macau' },
{ value: 'Madagascar', label: 'Madagascar' },
{ value: 'Malawi', label: 'Malawi' },
{ value: 'Malaysia', label: 'Malaysia' },
{ value: 'Maldives', label: 'Maldives' },
{ value: 'Mali', label: 'Mali' },
{ value: 'Malta', label: 'Malta' },
{ value: 'Marshall Islands', label: 'Marshall Islands' },
{ value: 'Martinique', label: 'Martinique' },
{ value: 'Mauritania', label: 'Mauritania' },
{ value: 'Mauritius', label: 'Mauritius' },
{ value: 'Mayotte', label: 'Mayotte' },
{ value: 'Mexico', label: 'Mexico' },
{ value: 'Republic of Moldova', label: 'Republic of Moldova' },
{ value: 'Monaco', label: 'Monaco' },
{ value: 'Mongolia', label: 'Mongolia' },
{ value: 'Montenegro', label: 'Montenegro' },
{ value: 'Montserrat', label: 'Montserrat' },
{ value: 'Morocco', label: 'Morocco' },
{ value: 'Mozambique', label: 'Mozambique' },
{ value: 'Myanmar, Burma', label: 'Myanmar, Burma' },
{ value: 'Namibia', label: 'Namibia' },
{ value: 'Nauru', label: 'Nauru' },
{ value: 'Nepal', label: 'Nepal' },
{ value: 'Netherlands', label: 'Netherlands' },
{ value: 'Netherlands Antilles', label: 'Netherlands Antilles' },
{ value: 'New Caledonia', label: 'New Caledonia' },
{ value: 'New Zealand', label: 'New Zealand' },
{ value: 'Nicaragua', label: 'Nicaragua' },
{ value: 'Niger', label: 'Niger' },
{ value: 'Nigeria', label: 'Nigeria' },
{ value: 'Niue', label: 'Niue' },
{ value: 'North Korea', label: 'North Korea' },
{ value: 'North Macedonia', label: 'North Macedonia' },
{ value: 'Northern Mariana Islands', label: 'Northern Mariana Islands' },
{ value: 'Norway', label: 'Norway' },
{ value: 'Oman', label: 'Oman' },
{ value: 'Pakistan', label: 'Pakistan' },
{ value: 'Palau', label: 'Palau' },
{ value: 'Palestinian territories', label: 'Palestinian territories' },
{ value: 'Panama', label: 'Panama' },
{ value: 'Papua New Guinea', label: 'Papua New Guinea' },
{ value: 'Paraguay', label: 'Paraguay' },
{ value: 'Peru', label: 'Peru' },
{ value: 'Philippines', label: 'Philippines' },
{ value: 'Pitcairn Island', label: 'Pitcairn Island' },
{ value: 'Poland', label: 'Poland' },
{ value: 'Portugal', label: 'Portugal' },
{ value: 'Puerto Rico', label: 'Puerto Rico' },
{ value: 'Qatar', label: 'Qatar' },
{ value: 'Reunion Island', label: 'Reunion Island' },
{ value: 'Romania', label: 'Romania' },
{ value: 'Russian Federation', label: 'Russian Federation' },
{ value: 'Rwanda', label: 'Rwanda' },
{ value: 'Saint Kitts and Nevis', label: 'Saint Kitts and Nevis' },
{ value: 'Saint Lucia', label: 'Saint Lucia' },
{ value: 'Saint Vincent and the Grenadines', label: 'Saint Vincent and the Grenadines' },
{ value: 'Samoa', label: 'Samoa' },
{ value: 'San Marino', label: 'San Marino' },
{ value: 'Sao Tome and Principe', label: 'Sao Tome and Principe' },
{ value: 'Saudi Arabia', label: 'Saudi Arabia' },
{ value: 'Senegal', label: 'Senegal' },
{ value: 'Serbia', label: 'Serbia' },
{ value: 'Seychelles', label: 'Seychelles' },
{ value: 'Sierra Leone', label: 'Sierra Leone' },
{ value: 'Singapore', label: 'Singapore' },
{ value: 'Slovakia (Slovak Republic)', label: 'Slovakia (Slovak Republic)' },
{ value: 'Slovenia', label: 'Slovenia' },
{ value: 'Solomon Islands', label: 'Solomon Islands' },
{ value: 'Somalia', label: 'Somalia' },
{ value: 'South Korea', label: 'South Korea' },
{ value: 'South Africa', label: 'South Africa' },
{ value: 'South Sudan', label: 'South Sudan' },
{ value: 'Spain', label: 'Spain' },
{ value: 'Sri Lanka', label: 'Sri Lanka' },
{ value: 'Sudan', label: 'Sudan' },
{ value: 'Suriname', label: 'Suriname' },
{ value: 'Swaziland (Eswatini)', label: 'Swaziland (Eswatini)' },
{ value: 'Sweden', label: 'Sweden' },
{ value: 'Switzerland', label: 'Switzerland' },
{ value: 'Syria, Syrian Arab Republic', label: 'Syria, Syrian Arab Republic' },
{ value: 'Taiwan (Republic of China)', label: 'Taiwan (Republic of China)' },
{ value: 'Tajikistan', label: 'Tajikistan' },
{ value: 'Tanzania', label: 'Tanzania' },
{ value: 'Thailand', label: 'Thailand' },
{ value: 'Tibet', label: 'Tibet' },
{ value: 'Timor-Leste (East Timor)', label: 'Timor-Leste (East Timor)' },
{ value: 'Togo', label: 'Togo' },
{ value: 'Tokelau', label: 'Tokelau' },
{ value: 'Tonga', label: 'Tonga' },
{ value: 'Trinidad and Tobago', label: 'Trinidad and Tobago' },
{ value: 'Tunisia', label: 'Tunisia' },
{ value: 'Turkey', label: 'Turkey' },
{ value: 'Turkmenistan', label: 'Turkmenistan' },
{ value: 'Turks and Caicos Islands', label: 'Turks and Caicos Islands' },
{ value: 'Tuvalu', label: 'Tuvalu' },
{ value: 'Uganda', label: 'Uganda' },
{ value: 'Ukraine', label: 'Ukraine' },
{ value: 'United Arab Emirates', label: 'United Arab Emirates' },
{ value: 'United Kingdom', label: 'United Kingdom' },
{ value: 'United States', label: 'United States' },
{ value: 'Uruguay', label: 'Uruguay' },
{ value: 'Uzbekistan', label: 'Uzbekistan' },
{ value: 'Vanuatu', label: 'Vanuatu' },
{ value: 'Vatican City State (Holy See)', label: 'Vatican City State (Holy See)' },
{ value: 'Venezuela', label: 'Venezuela' },
{ value: 'Vietnam', label: 'Vietnam' },
{ value: 'Virgin Islands (British)', label: 'Virgin Islands (British)' },
{ value: 'Virgin Islands (U.S.)', label: 'Virgin Islands (U.S.)' },
{ value: 'Wallis and Futuna Islands', label: 'Wallis and Futuna Islands' },
{ value: 'Western Sahara', label: 'Western Sahara' },
{ value: 'Yemen', label: 'Yemen' },
{ value: 'Zambia', label: 'Zambia' },
{ value: 'Zimbabwe', label: 'Zimbabwe' }

];


Objects.oldCountries = [

  'Afghanistan',
'Albania',
'Algeria',
'American Samoa',
'Andorra',
'Angola',
'Anguilla',
'Antarctica',
'Antigua and Barbuda',
'Argentina',
'Armenia',
'Aruba',
'Australia',
'Austria',
'Azerbaijan',
'Bahamas',
'Bahrain',
'Bangladesh',
'Barbados',
'Belarus',
'Belgium',
'Belize',
'Benin',
'Bermuda',
'Bhutan',
'Bolivia',
'Bosnia and Herzegovina',
'Botswana',
'Brazil',
'Brunei Darussalam',
'Bulgaria',
'Burkina Faso',
'Burundi',
'Cambodia',
'Cameroon',
'Canada',
'Cape Verde',
'Cayman Islands',
'Central African Republic',
'Chad',
'Chile',
'China',
'Christmas Island',
'Cocos (Keeling) Islands',
'Colombia',
'Comoros',
'Democratic Republic of the Congo (Kinshasa)',
'Congo, Republic of (Brazzaville)',
'Cook Islands',
'Costa Rica',
'Croatia',
'Cuba',
'Cyprus',
'Czech Republic',
'Denmark',
'Djibouti',
'Dominica',
'Dominican Republic',
'East Timor (Timor-Leste)',
'Ecuador',
'Egypt',
'El Salvador',
'Equatorial Guinea',
'Eritrea',
'Estonia',
'Ethiopia',
'Falkland Islands',
'Faroe Islands',
'Fiji',
'Finland',
'France',
'French Guiana',
'French Polynesia',
'French Southern Territories',
'Gabon',
'The Gambia',
'Georgia',
'Germany',
'Ghana',
'Gibraltar',
'Greece',
'Greenland',
'Grenada',
'Guadeloupe',
'Guam',
'Guatemala',
'Guinea',
'Guinea-Bissau',
'Guyana',
'Haiti',
'Holy See',
'Honduras',
'Hong Kong',
'Hungary',
'Iceland',
'India',
'Indonesia',
'Iran (Islamic Republic of)',
'Iraq',
'Ireland',
'Israel',
'Italy',
'Ivory Coast',
'Jamaica',
'Japan',
'Jordan',
'Kazakhstan',
'Kenya',
'Kiribati',
'Kosovo',
'Kuwait',
'Kyrgyzstan',
"Lao, People's Democratic Republic",
'Latvia',
'Lebanon',
'Lesotho',
'Liberia',
'Libya',
'Liechtenstein',
'Lithuania',
'Luxembourg',
'Macau',
'Madagascar',
'Malawi',
'Malaysia',
'Maldives',
'Mali',
'Malta',
'Marshall Islands',
'Martinique',
'Mauritania',
'Mauritius',
'Mayotte',
'Mexico',
'Micronesia, Federal States of',
'Moldova, Republic of',
'Monaco',
'Mongolia',
'Montenegro',
'Montserrat',
'Morocco',
'Mozambique',
'Myanmar, Burma',
'Namibia',
'Nauru',
'Nepal',
'Netherlands',
'Netherlands Antilles',
'New Caledonia',
'New Zealand',
'Nicaragua',
'Niger',
'Nigeria',
'Niue',
'North Korea',
'North Macedonia',
'Northern Mariana Islands',
'Norway',
'Oman',
'Pakistan',
'Palau',
'Palestinian territories',
'Panama',
'Papua New Guinea',
'Paraguay',
'Peru',
'Philippines',
'Pitcairn Island',
'Poland',
'Portugal',
'Puerto Rico',
'Qatar',
'Reunion Island',
'Romania',
'Russian Federation',
'Rwanda',
'Saint Kitts and Nevis',
'Saint Lucia',
'Saint Vincent and the Grenadines',
'Samoa',
'San Marino',
'Sao Tome and Principe',
'Saudi Arabia',
'Senegal',
'Serbia',
'Seychelles',
'Sierra Leone',
'Singapore',
'Slovakia (Slovak Republic)',
'Slovenia',
'Solomon Islands',
'Somalia',
'South Korea',
'South Africa',
'South Sudan',
'Spain',
'Sri Lanka',
'Sudan',
'Suriname',
'Swaziland (Eswatini)',
'Sweden',
'Switzerland',
'Syria, Syrian Arab Republic',
'Taiwan (Republic of China)',
'Tajikistan',
'Tanzania; officially the United Republic of Tanzania',
'Thailand',
'Tibet',
'Timor-Leste (East Timor)',
'Togo',
'Tokelau',
'Tonga',
'Trinidad and Tobago',
'Tunisia',
'Turkey',
'Turkmenistan',
'Turks and Caicos Islands',
'Tuvalu',
'Uganda',
'Ukraine',
'United Arab Emirates',
'United Kingdom',
'United States',
'Uruguay',
'Uzbekistan',
'Vanuatu',
'Vatican City State (Holy See)',
'Venezuela',
'Vietnam',
'Virgin Islands (British)',
'Virgin Islands (U.S.)',
'Wallis and Futuna Islands',
'Western Sahara',
'Yemen',
'Zambia',
'Zimbabwe'

];



module.exports = Objects;
